/* tslint:disable:max-line-length */

import { Injectable, NgZone } from '@angular/core';
import {FormControl, FormGroup} from '@angular/forms';
import {  Observable } from 'rxjs';
import { ResiduService } from '../../../controllers/Residu';
import * as __model from '../../../model';
import { APIConfigService } from '../../../apiconfig.service';

import * as __utils from '../../../yasag-utils';

import { YASAGGetFormService } from '../../yasag-get.service';


@Injectable()
export class ResiduListFormService extends YASAGGetFormService<__model.ResiduList> {
  static xImiRoles = {"admin":"administrator can use this endpoint"};
  form = new FormGroup({
    search: new FormControl({value: undefined, disabled: false}, []),
    limit: new FormControl({value: undefined, disabled: false}, []),
    offset: new FormControl({value: undefined, disabled: false}, []),
    codi_residu: new FormControl({value: undefined, disabled: false}, []),
    codi_fraccio: new FormControl({value: undefined, disabled: false}, []),
    id: new FormControl({value: undefined, disabled: false}, []),
    sinonim: new FormControl({value: undefined, disabled: false}, []),
    lang: new FormControl({value: undefined, disabled: false}, []),
    fields: new FormControl({value: undefined, disabled: false}, []),
    expand: new FormControl({value: undefined, disabled: false}, []),
  });
  constructor(
    apiConfigService: APIConfigService,
    ngZone: NgZone,
    private service: ResiduService,
  ) {
    super('ResiduList', apiConfigService, ngZone);
    this.init();
  }

  submit(value: typeof this.form.value | false = false, cache = true, only_cache = false): Observable<__model.ResiduList> {
    const result = val => this.service.list(val);
    return this._submit('__model.ResiduList', result, value, cache, only_cache );
  }
  listen(value: typeof this.form.value | false = false, submit: boolean = true): Observable<__model.ResiduList> {
    if (submit) {
      this.submit(value);
    }
    return this._listen('__model.ResiduList', value, submit);
  }


  reset(value?: typeof this.form.value): void {
    this.form.reset();
    super.reset(value, false); 
  }
  patch(value: typeof this.form.value): void {
    this.form.patchValue(value);
  }
}
